import { IMAGE_TYPE } from "./../../ricos-content";
const baseUrl = "/_serverless/ricos-media-services/media-token";
const getMediaToken = /* @__PURE__ */ (() => {
  let mediaToken;
  return async (instance) => {
    if (!mediaToken) {
      const response = await fetch(baseUrl, { headers: { Authorization: instance } });
      mediaToken = await response?.text?.();
    }
    return mediaToken;
  };
})();
const getImageEditorSettings = async (instance, metaSiteId, initiator = "ricos-default") => {
  const mediaToken = (await getMediaToken(instance))?.replace(/^"+|"+$/g, "");
  if (mediaToken && mediaToken.startsWith("JWS.")) {
    return {
      initiator,
      siteToken: mediaToken,
      metaSiteId,
      mediaRoot: "photos"
    };
  }
  return null;
};
function imageEditorStrategy(instance, metaSiteId, userId, consumer) {
  if (!(instance && userId && metaSiteId)) {
    return {
      config: {}
    };
  }
  const imageEditorWixSettings = getImageEditorSettings(instance, metaSiteId, consumer);
  return {
    config: {
      [IMAGE_TYPE]: {
        imageEditorWixSettings
      }
    }
  };
}
export {
  imageEditorStrategy as default
};
//# sourceMappingURL=imageEditorStrategy.js.map
